import React from 'react';
import Header from "../../../components/header";
import Footer from "../../../components/footer";
import { connect } from "react-redux";
import { addPractitioners } from "../../../services/facility/action";
import { NavLink } from "react-router-dom";
import { getNpiDetails } from "../../../services/common/action";
import $ from 'jquery';
import { footer } from "../../../components/footerSize";
import { onlyAlphabets, onlyNumbers} from "../../common/keyValidation"

class Practitioners extends React.Component {

    constructor(props) {
        super(props)
        let email = this.props.profileDetails.commonUser.email
        this.state = {
            item: {
                "firstName": "",
                "lastName": "",
                "email": "",
                "title": "",
                "npiNumber": "",
                "practiceType": "",
                "facilityEmail": email
            },
            data: [{
                "firstName": "",
                "lastName": "",
                "email": "",
                "title": "",
                "npiNumber": "",
                "practiceType": "",
                "facilityEmail": email
            }],
            npiKey: "",
            errors: [{
                firstName: "",
                lastName: "",
                email: "",
                title: "",
                npiNumber: "",
            }],
            firstNameValid: false,
            lastNameValid: false,
            emailValid: false,
            npiValid: false,
            degreeValid: false,
            formValid: false
        }
    }



    appendRow = (e) => {
        e.preventDefault();

        let item = Object.assign({}, this.state.item)
        item.firstName = ""
        item.lastName = ""
        item.email = ""
        item.title = ""
        item.npiNumber = ""
        item.practiceType = ""
        let data = this.state.data;

        let errorItem = Object.assign({}, this.state.errorItem)
        errorItem.firstName = ""
        errorItem.lastName = ""
        errorItem.email = ""
        errorItem.title = ""
        errorItem.npiNumber = ""
        let errors = this.state.errors;
        errors.push(errorItem);
        data.push(item);
        this.setState({
            item,
            data,
            errors,
            firstNameValid:false,
            lastNameValid:false,
            emailValid:false,
            npiValid:false,
            degreeValid:false,
            formValid:false
        })
    }

    deleteRow = (e, key) => {
        e.preventDefault();
        let data = this.state.data;
        let errors = this.state.errors;
        // delete data[key];
        data.splice(key, 1)
        errors.splice(key, 1)
        this.setState({
            data,
            errors,
            firstNameValid:true,
            lastNameValid:true,
            emailValid:true,
            npiValid:true,
            degreeValid:true,
            formValid:true
        })

    }



    validateField(fieldName, value, key) {
       
        const {
            errors,
            firstNameValid,
            lastNameValid,
            emailValid,
            npiValid,
            degreeValid

         } = this.state;

        let fieldValidationErrors = errors;
        let firstNamevalid = firstNameValid;
        let lastNamevalid = lastNameValid;
        let emailvalid = emailValid;
        let npivalid = npiValid;
        let degreevalid = degreeValid


        switch (fieldName) {

            case "firstName":
                firstNamevalid = !(value.length < 3 || value.length > 20);
                fieldValidationErrors[key].firstName = firstNamevalid
                    ? ""
                    : "First Name should be 3 to 20 characters";
           
                break;
            case "lastName":
                lastNamevalid = !(value.length < 3 || value.length > 20);
                fieldValidationErrors[key].lastName = lastNamevalid
                    ? ""
                    : "Last Name should be 3 to 20 characters";
                break;
            case "npiNumber":
                npivalid = value.match(/^\d{10}$/);
                fieldValidationErrors[key].npiNumber = npivalid
                    ? ""
                    : "Please enter valid NPI number";
                break;

            case "email":
                emailvalid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                fieldValidationErrors[key].email = emailvalid
                    ? ""
                    : " Please enter valid Email Address";
                break;
            case "title":
                degreevalid = !(value.length < 3 || value.length > 20);
                fieldValidationErrors[key].title = degreevalid
                    ? ""
                    : "Enter you designation here";
                break;
          default:
          break;
        }
   
        this.setState(
            {
                errors: fieldValidationErrors,
                firstNameValid: firstNamevalid,
                lastNameValid: lastNamevalid,
                emailValid: emailvalid,
                npiValid: npivalid,
                // degreeValid : degreevalid,
            },
            this.validateForm
        );
    }




    validateForm() {
        const {
         npiValid,
            lastNameValid,
            firstNameValid,
            emailValid,
      } = this.state;
        this.setState({

            formValid:
            lastNameValid &&
            firstNameValid &&
            emailValid &&
            npiValid
        });
    } 
















    firstChange = (e, key) => {
        const name = e.target.name;
        const value = e.target.value;
        let data = this.state.data;
        data[key].firstName = e.target.value

        this.setState({
            data,

        }, () => {
            this.validateField(name, value, key)
        })
    }

    secondChange = (e, key) => {
        const name = e.target.name;
        const value = e.target.value;
        let data = this.state.data;
        data[key].lastName = e.target.value

        this.setState({
            data,

        }, () => {
            this.validateField(name, value, key)
        })
    }

    thirdChange = (e, key) => {
        const name = e.target.name;
        const value = e.target.value;
        let data = this.state.data;
        data[key].email = e.target.value

        this.setState({
            data,

        }, () => {
            this.validateField(name, value, key)
        })
    }

    fourChange = (e, key) => {
        const name = e.target.name;
        const value = e.target.value;
        let data = this.state.data;
        data[key].title = e.target.value

        this.setState({
            data,

        }, () => {
            this.validateField(name, value, key)
        })
    }

    fiveChange = (e, key) => {
        const name = e.target.name;
        const value = e.target.value;
        let data = this.state.data;
        data[key].npiNumber = e.target.value

        this.setState({
            data,

        }, () => {
            this.validateField(name, value, key)
        })
    }

    sixChange = (e, key) => {
        const name = e.target.name;
        const value = e.target.value;
        let data = this.state.data;
        data[key].practiceType = e.target.value

        this.setState({
            data,

        }, () => {
            this.validateField(name, value, key)
        })
    }

    npiChange = (e, key) => {
        const name = e.target.name;
        const value = e.target.value;
        let data = this.state.data;
        let npiKey = key
        data[key].npiNumber = e.target.value

        this.setState({
            npiKey,
            data
        }, () => {
            this.validateField(name, value, key);
            if (this.state.data[key].npiNumber.length == 10) {
                let payLoad = {
                    "number": this.state.data[key].npiNumber,
                    "enumeration_type": "",
                    "taxonomy_description": "",
                    "first_name": "",
                    "use_first_name_alias": "",
                    "last_name": "",
                    "organization_name": "",
                    "address_purpose": "",
                    "city": "",
                    "state": "",
                    "postal_code": "",
                    "country_code": "",
                    "limit": "",
                    "skip": "",
                    "version": ""
                }
               // let page = "practitioner"

                this.props.getNpiDetails(payLoad);

            }
        })
    }
 

    savePractitionersData = (e) => {
        e.preventDefault();
        let access_token = this.props.loginDetails;

        let payLoad = this.state.data

        this.props.addPractitioners(access_token, payLoad, )
    
    }
    componentDidMount() {
        // onDocumentReady function bind
        $(document).ready(function () {
            footer("#container");
        });

        // onResize bind of the function
        $(window).resize(function () {
            footer("#container");
        });
    }

    componentWillReceiveProps = nextProps => {
        if (nextProps.addPractitionersStatus) {
            this.props.history.push("Settings")
        }
        if (nextProps.getNpiStatus) {
            if (nextProps.getNpiData.npiInfo) {
            if(nextProps.getNpiData.npiInfo.map.results.myArrayList.length > 0){
 
     
             let basic_data = nextProps.getNpiData.npiInfo.map.results.myArrayList[0].map.basic.map
           //  let address_data = nextProps.getNpiData.npiInfo.map.results.myArrayList[0].map.addresses.myArrayList[0].map
                let firstName = basic_data.first_name;
                let lastName = basic_data.last_name;
                let data = this.state.data;
                let key = this.state.npiKey;
                data[key].firstName = firstName;
                data[key].lastName =  lastName;
                this.setState({
                  data,
                  firstNameValid : true,
                  lastNameValid : true,
                })
            }

        }
    }
    }



    render() {
        const { errors, formValid } = this.state;
     
        return (
            <>

    
           

            <div className="registration-wrapper">
                <Header status={"afterLogin"} />
                <div className="container">

                    <div className="login-bg btns">

                        <div className="login-form">

                            <h1>Practitioner</h1>
                            <form>
                                <div className="row">
                                    {this.state.data.map((item, key) => {
                                        return (
                                                <>
                                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" key={key}>
                                                <div className="card-box-request">
                                                    <div className="row">
                                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                            <div className="form-group">
                                                                <label>NPI Number<sup>*</sup></label> 
                                                                <input type="text" name="npiNumber"  value={item.npiNumber} onChange={(e) => this.npiChange(e, key)} onKeyPress={onlyNumbers} placeholder="NPI number" maxLength="10"/>                                                                <span className="error">This value is required</span>
                                                                <span className="error">This value is required</span>
                                                                <span className="error-red">{errors[key].npiNumber}</span>

                                                            </div>
                                                        </div>

                                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                            <div className="form-group">
                                                                <label>Email ID<sup>*</sup></label> 
                                                                <input type="text" name="email"  value={item.email} onChange={(e) => this.thirdChange(e, key)} placeholder="Email" />
                                                                <span className="error-red">{errors[key].email}</span>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row ">
                                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                            <div className="form-group">
                                                                <label>First Name<sup>*</sup></label>
                                                                <input type="text" name="firstName"  value={item.firstName} onKeyPress={onlyAlphabets} onChange={(e) => this.firstChange(e, key)} placeholder="First Name" />
                                                                <span className="error">This value is required</span>
                                                                <span className="error-red">{errors[key].firstName}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12" >
                                                        <div className="form-group">
                                                                <label>Last Name<sup>*</sup></label>
                                                                <input type="text" name="lastName" value={item.lastName}  onKeyPress={onlyAlphabets} onChange={(e) => this.secondChange(e, key)} placeholder="Last Name" />
                                                                <span className="error-red">{errors[key].lastName}</span>

                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row ">
                                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                         
                                                            <div className="form-group">
                                                                <label>Degree</label> 
                                                                <input type="text" name="title"  value={item.title} onKeyPress={onlyAlphabets} onChange={(e) => this.fourChange(e, key)} placeholder="Degree" />
                                                                <span className="error">This value is required</span>

                                                            </div>
                                                        </div>
                                                    </div>


                                                    {this.state.data.length > 1 &&
                                                        <div>
                                                            <a href="javascript:void(0)"  className="trash-btn" onClick={(e) => this.deleteRow(e, key)}>
                                                                <i className="fa fa-trash-o" aria-hidden="true"></i>
                                                            </a>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                              
                                            </>


                                            )
                                        })
                                        }


                                    </div>
                                    <div className="form-group">
                                        <div className="addme">
                                        <button disabled={!formValid} onClick={this.appendRow} >
                                             <i className="fa fa-plus" aria-hidden="true"></i>Add more
                                        Practitioners </button>
                                        </div>
                                    </div>
                                




                                <div className="form-group">
                                    <NavLink to="/Settings">
                                        <button type="button" className="loginbtn-submit1 green">Cancel</button>
                                    </NavLink>
                                    <a>
                                        <button type="button" disabled={!formValid} onClick={this.savePractitionersData} className="loginbtn-submit1 green">Save</button>
                                    </a>
                                </div>
                                 

                            </form>
                        </div>
                    </div>


                </div>

            </div>

            <Footer />

            </>
        )
    }
}

const mapStateToProps = state => ({
    profileDetails: state.commonReducer.profileDetails,
    loginDetails: state.commonReducer.loginDetails,
    addPractitionersStatus: state.facilityReducer.addPractitionersStatus,
    getNpiStatus: state.commonReducer.getNpiStatus,
    getNpiData: state.commonReducer.getNpiData,

    //message: state.commonReducer.message

});
const mapDispatchToProps = dispatch => ({
    addPractitioners: (token, payLoad) => dispatch(addPractitioners(token, payLoad)),
    getNpiDetails: (payload) => dispatch(getNpiDetails(payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Practitioners);

